import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['mobileNav', 'line1', 'line2', 'line3', 'nav']

  connect() {
    this.open = false
    this.setupScrollListener()
  }

  disconnect() {
    window.removeEventListener('scroll', this.handleScroll)
  }

  setupScrollListener() {
    this.handleScroll = () => {
      this.navTarget.classList.toggle('scrolled', window.scrollY > 20)
    }
    window.addEventListener('scroll', this.handleScroll)
  }

  toggleMenu() {
    this.open = !this.open
    this.mobileNavTarget.classList.toggle('nav-mobile--open', this.open)

    if (this.open) {
      this.line1Target.style.transform = 'rotate(45deg) translate(5px, 5px)'
      this.line2Target.style.opacity = '0'
      this.line3Target.style.transform = 'rotate(-45deg) translate(5px, -5px)'
    } else {
      this.resetLines()
    }
  }

  closeMenu() {
    this.open = false
    this.mobileNavTarget.classList.remove('nav-mobile--open')
    this.resetLines()
  }

  resetLines() {
    this.line1Target.style.transform = ''
    this.line2Target.style.opacity = ''
    this.line3Target.style.transform = ''
  }
}
